"use client"
import TextFieldComponent from "@/Inputs/TextFieldComponent";
import localStorageCall from "@/services/Methods/localstorage.hook";
import { Fragment, useMemo, useState } from "react";
import { getCustomerRefferal } from "@/services/Redux/Reducer/CustomerSlice";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import { Close, Search } from "@mui/icons-material";
import ButtonComponent from "@/Inputs/ButtonComponent";
import { MiniLoader, _scrollToUp, _setTimeOut, cn, storeAssigned } from "@/services/Methods/normalMethods";
import { RegionDropdown } from "react-country-region-selector";
import { createSelector } from 'reselect';
import { useRouter } from "next/navigation";
import _, { ceil } from "lodash";
import ReactpaginateComp from "@/comman/ReactPaginateComp";
import { RefferalContent } from "@/comman/RefferalCheckPopup";
import withRouteHOC from "@/HOC/withRouterHOC";

const ReferralResultsView = ({ data, onSelect }) => {
    const sanitizedRows = useMemo(() => _.reject(data, { customerId: 100 }), [data]);

    if (!sanitizedRows?.length) {
        return null;
    }

    return (
        <>
            <div className="hidden md:block max-h-[400px] overflow-y-auto overflow-x-hidden pr-2">
                <table className="w-full table-fixed border-collapse referral-search-table">
                    <colgroup>
                        <col style={{ width: '15%' }} />
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '25%' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            {_.map(['ID', 'Name', 'Code', 'Action'], (row) => (
                                <th key={row} className="border border-[#ddd] p-[10px] text-left text-sm font-semibold bg-[#f8f8f8]">
                                    {row}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {sanitizedRows.map((customer) => (
                            <tr className="p-5" key={customer?.customerId}>
                                <td className="border border-[#ddd] p-[10px] text-sm break-words">{customer?.customerId}</td>
                                <td className="border border-[#ddd] p-[10px] text-sm break-words">{customer?.publicProfile?.fullName}</td>
                                <td className="border border-[#ddd] p-[10px] text-sm break-words">{customer?.webAlias || 'N/A'}</td>
                                <td className="border border-[#ddd] p-[10px]">
                                    <ButtonComponent
                                        classes="!mb-0 w-full bg-[#428bca] text-[#fff] !p-[6px_16px] !rounded-[4px]"
                                        onClick={() => onSelect(customer)}
                                    >
                                        Select
                                    </ButtonComponent>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="md:hidden flex flex-col gap-3 max-h-[400px] overflow-y-auto pr-1">
                {sanitizedRows.map((customer) => (
                    <div key={customer?.customerId} className="border border-[#ddd] rounded-md p-4 shadow-sm bg-white">
                        <div className="mb-2 text-sm flex justify-between">
                            <span className="font-semibold">ID</span>
                            <span>{customer?.customerId}</span>
                        </div>
                        <div className="mb-2 text-sm flex justify-between">
                            <span className="font-semibold">Name</span>
                            <span className="text-right">{customer?.publicProfile?.fullName}</span>
                        </div>
                        <div className="mb-3 text-sm flex justify-between">
                            <span className="font-semibold">Code</span>
                            <span>{customer?.webAlias || 'N/A'}</span>
                        </div>
                        <ButtonComponent
                            classes="!mb-0 w-full bg-[#428bca] text-[#fff] !p-[6px_16px] !rounded-[4px]"
                                        onClick={() => onSelect(customer)}
                        >
                            Select
                        </ButtonComponent>
                    </div>
                ))}
            </div>
        </>
    );
};

const ReferralPopup = (props) => {
    const { section, openPopup, setOpenPopup, searcheddata, setSearcheddata, offset, setOffSet, router } = props;
    const dispatch = useDispatch();

    const mamoSelector = createSelector(
        (state) => state?.CustomerSlice?.isLoading,
        (data) => ({ isLoading: data })
    )
    const { isLoading } = useSelector((state) => mamoSelector(state))

    const InputField = (name, label, value, handleChange, type, disable) => {
        return (
            <div className='md-3-field xl:mb-[34px] mb-[24px]'>
                <TextFieldComponent
                    name={name}
                    type={type ? type : 'text'}
                    label={label}
                    value={value.trim()}
                    errorMessage={" "}
                    // disabled={disable}
                    divClass={'w-full !mb-0'}
                    onChange={handleChange}
                />
            </div>
        )
    };

    const [referraldata, setReferraldata] = useState({ data: [], totalRecords: 0 });
    const [errorDisplay, setErrorDisplay] = useState('');

    const selectedItem = (data) => {
        const refferalData = { "id": data?.customerId, "name": data?.fullName || data?.publicProfile?.fullName, "webalies": data?.webAlias, userDetail: data, "type": data?.customerTypeDescr };

        if (props?.urlRefferal?.webalies) {
            // urlRefferal, setUrlRefferal, _handleYesClick
            props?._handleYesClick('yes', refferalData)

        } else {
            console.log(referraldata)
            console.log("data", data)
            console.log("inside_the_esectonfsjfjf");
            localStorageCall().setItem("refferal_link", JSON.stringify(refferalData));
            setOpenPopup(false)
            setReferraldata([]);
            router.push(`/${storeAssigned()}/${section}`)
        }

    }

    const [formData, setFormData] = useState({ firstName: '', lastName: '', city: '', zipcode: '', state: '', webAlias: '' });
    const [selectedReferral, setSelectedReferral] = useState(null);

    const handleformChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleFormSubmit = (e, currentPage = offset - 1) => {
        if (e)
            e.preventDefault();
        console.log(formData, offset, 'formDataformDataformData')
        // const VALUES = _.compact(_.values(formData));
        const VALUES = _.compact(_.values(formData)).map(value => value.trim());

        if (VALUES?.length > 0) {
            dispatch(getCustomerRefferal((data, totalRecords) => {
                if (data?.length > 0) {
                    setReferraldata({ data: data, totalRecords })
                    setSearcheddata('list')

                } else {
                    setErrorDisplay('No record found with these detail');
                    _setTimeOut(() => setErrorDisplay(''), 3000);
                }
            }, formData, 'normal', currentPage));
            // setFormData(VALUES);
            // setFormData({ firstName: '', lastName: '', city: '', zipcode: '', state: '' })
        } else {
            setErrorDisplay('Please fill any field for search');
            _setTimeOut(() => setErrorDisplay(''), 3000);
        }

    }

    function _onPaginationChange(e) {
        const selectedPage = e.selected;
        const offsetpage = selectedPage + 1;
        setOffSet(offsetpage)

        handleFormSubmit(null, offsetpage - 1);

        // dispatch(getAllProductApiPagination(offsetpage - 1))
        _scrollToUp();
        // paginateData(Logintoken, offsetpage)
    }

    const route = useRouter()


    const closePopup = () => {
        setOpenPopup(false)
        // if (section === 'checkout') {
        //     router.push(`/${storeAssigned()}/${section}`)
        // }
        route.back()
    }
    const blacklist_state = { US: ['AS', 'FM', 'GU', 'MH', 'MP', 'PW', 'PR', 'AA', 'AE', 'AP'] };
    const handleReferralRowSelection = (customer) => {
        setSearcheddata('confirmation');
        setSelectedReferral(customer);
    };

    return (
        <Transition appear show={openPopup} as={Fragment}>
            <Dialog as="div" className="relative z-[1400]" onClose={() => console.log('close')}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-[rgba(0,0,0,0.8)]" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center text-center px-[15px] max-[404px]:px-[8px]">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel
                                className={cn("z-[1400] mx-0 w-full max-w-[800px] transform md:p-7 p-5 max-[404px]:p-3 bg-white  text-left align-middle  transition-all rounded-md", { "max-w-[470px]": searcheddata === "confirmation" })}>
                                {!props?.urlRefferal?.webalies &&
                                    <div className="text-right">
                                        <Close
                                            className="mb-1 ml-auto cursor-pointer"
                                            onClick={() => {
                                                // setOpenPopup(false);
                                                // if (section === 'checkout') {
                                                //     router.push(`/${storeAssigned()}/${section}`)
                                                // }
                                                closePopup()
                                            }}
                                        />
                                    </div>
                                }
                                <div className="py-2 mb-[20px]">
                                    <h3 className="font-bold">Referral Search</h3>
                                </div>
                                {
                                    (searcheddata === "list") &&
                                    <div className="">
                                        <div className="md:h-[400px] h-[300px] overflow-y-scroll overflow-x-hidden">
                                            <ReferralResultsView
                                                data={referraldata?.data}
                                                onSelect={handleReferralRowSelection}
                                            />
                                        </div>
                                        {
                                            (referraldata?.data?.length > 0) &&
                                            <div className="md:mt-0 -mt-[20px] sm:-mt-[15px]">
                                                <ReactpaginateComp currentPage={offset} pageCount={ceil(referraldata?.totalRecords / 10)} handlePageClick={(e) => {
                                                    _onPaginationChange(e)
                                                }} />
                                            </div>
                                        }
                                        <div className="bg-white-500">
                                            <div className="w-full max-w-[200px] my-0 mx-auto relative  mt-[12px]">
                                                <ButtonComponent classes="text-[18px] !mb-0 bg-[#428bca] text-[#fff] !p-[4px_20px] !rounded-[4px]" onClick={() => {
                                                    setSearcheddata('form');
                                                    setOffSet(1);
                                                }}> Back</ButtonComponent>
                                            </div>
                                        </div>

                                    </div>
                                }
                                {(searcheddata === "form") &&
                                    <form action="" onSubmit={handleFormSubmit}>
                                        <div className='row-form gap-[0_16px] flex flex-wrap'>
                                            <div className="sm:w-[calc(100%/2-8px)] w-full">
                                                {InputField('firstName', "First Name", formData.firstName, handleformChange)}
                                            </div>
                                            <div className="sm:w-[calc(100%/2-8px)] w-full">
                                                {InputField('lastName', "Last Name", formData.lastName, handleformChange)}
                                            </div>
                                            <div className="sm:w-[calc(100%/2-8px)] w-full">
                                                {InputField('city', "City", formData.city, handleformChange)}
                                            </div>
                                            <div className="sm:w-[calc(100%/2-8px)] w-full">
                                                {InputField('zipcode', "Zip Code", formData.zipcode, handleformChange)}
                                            </div>
                                            <div className="sm:w-[calc(100%/2-8px)] w-full xl:mb-[34px] mb-[24px]">
                                                <label
                                                    htmlFor={name}
                                                    className="text-black text-base font-medium peer-focus:!font-medium peer-focus:!text-base duration-300 top-[0.3rem] z-10 origin-[0] start-3.5 pointer-events-none"
                                                >
                                                    State
                                                </label>
                                                <RegionDropdown
                                                    country={"US"}
                                                    blacklist={blacklist_state}
                                                    value={formData.state}
                                                    name="state"
                                                    valueType="short"
                                                    defaultOptionLabel={"State"}
                                                    countryValueType="short"
                                                    className="floating-input bg-[transparent] border-clr border-[1px] px-3.5 pt-4 pb-3 block w-full font-medium placeholder:text-black text-base rounded-[6px] h-[47px]"
                                                    onChange={(e) => { handleformChange({ target: { name: 'state', value: e } }) }}
                                                />
                                            </div>
                                            <div className="sm:w-[calc(100%/2-8px)] w-full">
                                                {InputField('webAlias', "Web-Alias", formData.webAlias, handleformChange)}
                                            </div>
                                        </div>
                                        <div className="w-full  max-w-[300px] my-4 mx-auto">
                                            <ButtonComponent classes="text-[18px] !mb-0 bg-[#428bca] text-[#fff] !p-[6px_20px] !rounded-[4px]" type="submit" disabled={isLoading}>{isLoading ? <MiniLoader /> : <><Search />Search</>}</ButtonComponent>
                                        </div>
                                        {errorDisplay && <div className="text-sm text-center text-red-500 mt-2">{errorDisplay}</div>}
                                    </form>
                                }
                                {searcheddata === "confirmation" &&

                                    <RefferalContent {...{
                                        urlRefferal: { userDetail: selectedReferral },
                                        yesFunction: () => selectedItem(selectedReferral),
                                        noFunction: () => setSearcheddata('list')
                                    }} />
                                }
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default withRouteHOC(ReferralPopup);